import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=1d15fdf4&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=1d15fdf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d15fdf4",
  null
  
)

export default component.exports